import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import api from "@/lib/api";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import PageTracker from "@/components/PageTracker";

import Home from "@/pages/Home";
import Writings from "@/pages/Writings";
import PostReader from "@/pages/PostReader";
import About from "@/pages/About";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEditor from "@/pages/AdminEditor";
import AdminBook from "@/pages/AdminBook";
import AdminProfile from "@/pages/AdminProfile";
import AdminSubscribers from "@/pages/AdminSubscribers";
import AdminHomepage from "@/pages/AdminHomepage";
import AdminPages from "@/pages/AdminPages";
import AdminReviews from "@/pages/AdminReviews";
import AdminMissions from "@/pages/AdminMissions";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminSongs from "@/pages/AdminSongs";
import AdminSongEditor from "@/pages/AdminSongEditor";
import AdminJourney from "@/pages/AdminJourney";
import AdminAnnouncement from "@/pages/AdminAnnouncement";
import AdminSlides from "@/pages/AdminSlides";
import Book from "@/pages/Book";
import Listen from "@/pages/Listen";
import LucysJourney from "@/pages/LucysJourney";
import AnnouncementBanner from "@/components/AnnouncementBanner";

const SCALE_PX = { small: "14px", default: "16px", comfortable: "17px", large: "19px" };

function App() {
  useEffect(() => {
    api.get("/homepage")
      .then((r) => {
        const px = SCALE_PX[r.data?.text_scale] || "16px";
        document.documentElement.style.fontSize = px;
      })
      .catch(() => {});
  }, []);

  return (
    <div className="App bg-paper text-ink">
      <HelmetProvider>
        <BrowserRouter>
        <AuthProvider>
          <PageTracker />
          <AnnouncementBanner />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/writings" element={<Writings />} />
              <Route path="/writings/:slug" element={<PostReader />} />
              <Route path="/book" element={<Book />} />
              <Route path="/lucys-journey" element={<LucysJourney />} />
              <Route path="/listen" element={<Listen />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/new"
                element={
                  <ProtectedRoute>
                    <AdminEditor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/edit/:id"
                element={
                  <ProtectedRoute>
                    <AdminEditor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/book"
                element={
                  <ProtectedRoute>
                    <AdminBook />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/profile"
                element={
                  <ProtectedRoute>
                    <AdminProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/subscribers"
                element={
                  <ProtectedRoute>
                    <AdminSubscribers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/homepage"
                element={
                  <ProtectedRoute>
                    <AdminHomepage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/pages"
                element={
                  <ProtectedRoute>
                    <AdminPages />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/reviews"
                element={
                  <ProtectedRoute>
                    <AdminReviews />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/missions"
                element={
                  <ProtectedRoute>
                    <AdminMissions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/analytics"
                element={
                  <ProtectedRoute>
                    <AdminAnalytics />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/songs"
                element={
                  <ProtectedRoute>
                    <AdminSongs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/songs/:id"
                element={
                  <ProtectedRoute>
                    <AdminSongEditor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/journey"
                element={
                  <ProtectedRoute>
                    <AdminJourney />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/announcement"
                element={
                  <ProtectedRoute>
                    <AdminAnnouncement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/slides"
                element={
                  <ProtectedRoute>
                    <AdminSlides />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#2C2A28",
                color: "#FDFBF7",
                border: "1px solid #2C2A28",
                fontFamily: "Work Sans, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
